import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../fulfillment-planner/labeled-row/messages';
import classnames from 'clsx';

import { LabeledRow } from '../../../fulfillment-planner/labeled-row';
import { ShipmentStatusLabelContainer } from '../../../containers/status-label/shipment';

import style from './style.module.css';

export const ShipmentStatus = ({ fulfillmentPlanId, markedAsShipped = false, showMdash = false }) => (
  <LabeledRow className={style.row} label={<FormattedMessage {...messages.status} />} labelClassName={style.label}>
    <span
      className={classnames(style.info, {
        [style['marked-as-shipped']]: showMdash,
      })}
    >
      {showMdash ? (
        <span className={style.mdash}>&mdash;</span>
      ) : (
        <ShipmentStatusLabelContainer fulfillmentPlanId={fulfillmentPlanId} standalone />
      )}
      {!showMdash && markedAsShipped && <FormattedMessage {...messages.markShipped} />}
    </span>
  </LabeledRow>
);

ShipmentStatus.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  showMdash: PropTypes.bool,
  markedAsShipped: PropTypes.bool,
};
